<template>
  <div class="font_size">
    <el-skeleton :count="30" :loading="loading" animated>
      <el-container>
        <el-header height="300px" style="margin: 0;padding: 0;">
          <Head></Head>
        </el-header>
        <el-main style="margin: 0;padding: 0;">
          <div class="windowsWidth">
            <div class="u-flex  c-border-b u-height-45">
              <div class="u-font-16">当前的位置：</div>
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }" class="u-font-16">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-for="item in location" :key='item.tid' :to="{ path: '/' }" class="u-font-16">
                  {{ item.title }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="u-font-28 u-font-bold u-text-center u-m-t-20 u-line-height-40">{{ item.title }}</div>
            <div class="u-font-16 u-m-t-20 c-bg-f4f3f3 u-height-40 u-line-height-40 u-text-center">
              <span class="u-p-r-30">发布时间：{{ item.editTime || item.addTime }} </span>
              <span class="u-p-r-30">浏览量：{{ item.viewNum }} </span>
              <span class="u-p-r-30">来源：{{ item.sourceFrom }} </span>
            </div>
            <div class="u-m-t-20 u-m-b-20" v-html="item.content">

            </div>
          </div>
        </el-main>
        <el-footer style="margin: 0;padding: 0;">
          <Foot></Foot>
        </el-footer>
      </el-container>
    </el-skeleton>
  </div>
</template>

<script>
import Head from '@/components/head.vue'
import Foot from '@/components/foot.vue'

export default {
  name: 'cmsdetails',
  components: {Head, Foot},
  data() {
    return {
      loading: true,
      item: {},
      location: []
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$api.cms.apiCmsDetail({tid: this.$route.params.tid}).then(res => {
        this.item = res.data.details
        this.location = res.data.classLocation
        this.loading = false

      })
    }
  }
}
</script>

<style>
.font_size {
  font-size: 18px !important;
  color: #333;
  font-weight: 400;
  font-family: "Microsoft Yahei";
}

.u-m-t-20 p {
  margin: 5px auto !important;
  padding: 0 !important;
}

.u-m-t-20 p span {
  font-family: "Microsoft Yahei" !important;
}
</style>
